import Raven from 'raven-js';
import differenceInDays from 'date-fns/difference_in_days';

const DATA_KEY = 'invoiceData';
const NEXT_PERIOD_DATA_KEY = 'nextPeriodInvoiceData';


/**
 * @param {object} data -данные для кеширования:
 * @param {string} data.uid - id заказ
 * @param {string} data.phone - телефон клиента
 * @param {string} data.invoiceState - состояние заказа, нужно ли его подтверждение по смс
 * @param {string} data.deliveryDate - дата доставки
 * @param {string} data.invoicePaymentMethod - способ оплаты cash, online, recurrent
 * @param {string} data.orderDate - дата оформления заказа
 */
export const cacheInvoiceData = (data) => {
    try {
        localStorage.setItem(DATA_KEY, JSON.stringify(data));
    } catch (e) { } // eslint-disable-line no-empty
};

export const getCachedInvoiceData = () => {
    try {
        const data = JSON.parse(localStorage.getItem(DATA_KEY)) || {};
        const date = new Date(data.orderDate);

        if (!data.orderDate || differenceInDays(new Date(), date) > 1) {
            cacheInvoiceData({});
            return {};
        }
        return data;
    } catch (e) {
        Raven.captureException(e);
        return {};
    }
};

/**
 * удаляет все данные, кроме телефона пользователя
 */
export const clearCachedInvoiceData = () => {
    const data = getCachedInvoiceData();
    const dataToPass = data?.phone
        ? { ...data, phone: data.phone }
        : { ...data };
    cacheInvoiceData(dataToPass);
};

/**
 * кеширует доп. инвойс на корзину следующего цикла, чтобы карточка
 * «Спасибо за заказ» показала оба заказа с их датами.
 * Отдельный ключ: основной инвойс пишется позже (после оплаты) и
 * перезаписал бы общие данные
 *
 * @param {object} data
 * @param {string} data.uid - id доп. инвойса
 * @param {number} data.price - сумма доп. инвойса
 * @param {string} data.deliveryDate - дата доставки доп. заказа
 */
export const cacheNextPeriodInvoice = (data) => {
    try {
        localStorage.setItem(NEXT_PERIOD_DATA_KEY, JSON.stringify({
            ...data,
            orderDate: (new Date()).toISOString(),
        }));
    } catch (e) { } // eslint-disable-line no-empty
};

/**
 * сбрасывается перед созданием нового основного инвойса, чтобы данные
 * прошлого заказа не попали в карточку нового
 */
export const clearCachedNextPeriodInvoice = () => {
    try {
        localStorage.removeItem(NEXT_PERIOD_DATA_KEY);
    } catch (e) { } // eslint-disable-line no-empty
};

export const getCachedNextPeriodInvoice = () => {
    try {
        const data = JSON.parse(localStorage.getItem(NEXT_PERIOD_DATA_KEY)) || {};
        const date = new Date(data.orderDate);

        if (!data.orderDate || differenceInDays(new Date(), date) > 1) {
            clearCachedNextPeriodInvoice();
            return {};
        }
        return data;
    } catch (e) {
        Raven.captureException(e);
        return {};
    }
};

// const TRACK_DATA_KEY = 'trackPurchaseData';

// export const cacheTrackPurchaseData = (data) => {
//     try {
//         sessionStorage.setItem(TRACK_DATA_KEY, JSON.stringify(data));
//     } catch (e) {} // eslint-disable-line no-empty
// };

// export const getCachedTrackPurchaseData = () => {
//     try {
//         return JSON.parse(sessionStorage.getItem(TRACK_DATA_KEY));
//     } catch (e) {
//         Raven.captureException(e);
//         return null;
//     }
// };

// export const clearCachedTrackPurchaseData = () => sessionStorage.removeItem(TRACK_DATA_KEY);
